import Navigo from 'navigo';
import HeroesPage from './pages/HeroesPage';
import ProfilePage from './pages/ProfilePage';
import StoriesPage from './pages/StoriesPage';
import UniversesPage from './pages/UniversesPage';

export default class Router {
    constructor(app){
        this.app = app;
        this.router = null;
        this.currentPage = null;

        this.routes =[
            {
                path: '/',
                component: UniversesPage,
                title: 'Universes'
            },
            {
                path: '/heroes',
                component: HeroesPage,
                title: 'Heroes'
            },
            {
                path: '/stories',
                component: StoriesPage,
                title: 'Stories'
            },
            {
                path: '/profile',
                component: ProfilePage,
                title: 'Profile'
            }
        ];
    }

    init(){
        this.router = new Navigo('/', {
            hash: false,
            linksSelector: 'a[data-link]',
            updateState: true
        });

        this.routes.forEach(route => {
            this.router.on(route.path, (params) => {
                this.handleRoute(route, params);
            })
        })
        this.router.resolve()
    }

    async handleRoute(route, params){
        // close current page
        if (this.currentPage && this.currentPage.unmount){
            this.currentPage.unmount();
        }

        // create new page
        const page = new route.component(this.app, params);
        this.currentPage = page;

        // call live cycle hooks
        // await page.beforeMount();

        // mount page
        await page.mount(this.app.layout.contentContainer);

        // update active links
        this.updateActiveLinks(route.path);

        this.app.pathStory.push(route.path);

        // after mount
        // await page.afterMount();
    }

    handleNotFound() {
    const container = this.app.layout.contentContainer;
    container.innerHTML = `
        <div class="page-404">
        <h1>404</h1>
        <p>Страница не найдена</p>
        <a href="/" data-link>Вернуться на главную</a>
        </div>
    `;
    }

    updatePageTitle(params) {
    const route = this.routes.find(r => 
        this.router.lastRouteResolved().url === r.path
    );

    if (route) {
        document.title = `${route.title} | Project Manager`;
    }
    }

    updateActiveLinks(currentPath) {
    // Обновляем активные классы в меню
    document.querySelectorAll('a[data-link]').forEach(link => {
        const href = link.getAttribute('href');
        
        // Простое сравнение путей
        if (href === currentPath || 
            (href !== '/' && currentPath.startsWith(href))) {
        link.classList.add('active');
        } else {
        link.classList.remove('active');
        }
    });
    }

    navigate(path) {
        this.router.navigate(path);
    }

    getCurrentRoute() {
        const currentPath = window.location.pathname;
        // const match = this.router.match(currentPath);
        
        return currentPath;
    }
}